import type { ReactNode } from 'react';
import { Card, Text } from '@servicetitan/anvil2';
import preApprovalBadge from './pre-approval-badge.svg';
import {
    actions,
    banner,
    content,
    details,
    expiration,
    iconPanel,
    row,
} from './PreApprovalBanner.module.scss';

interface PreApprovalBannerCardProps {
    title: ReactNode;
    expiresAt?: string | null;
    className?: string;
    children?: ReactNode;
    actions?: ReactNode;
}

/**
 * Presentational Select-Plan pre-approval card: badge panel + title + optional expiration + an actions
 * slot. Shared by the store-driven `PreApprovalBanner` and the prequals-banner provider banners so
 * each keeps its provider-specific actions while rendering the same card.
 */
export const PreApprovalBannerCard = ({
    title,
    expiresAt,
    className,
    children,
    actions: actionContent,
}: PreApprovalBannerCardProps) => (
    <Card padding="0" className={[banner, className].filter(Boolean).join(' ')}>
        <div className={row}>
            <div className={iconPanel}>
                <img src={preApprovalBadge} alt="" width={48} height={48} />
            </div>
            <div className={content}>
                <div className={details}>
                    <Text variant="headline" el="h3" size="small">
                        {title}
                    </Text>
                    {expiresAt && (
                        <p className={expiration}>Offer expires {formatExpiration(expiresAt)}.</p>
                    )}
                    {children}
                </div>
                {actionContent != null && <div className={actions}>{actionContent}</div>}
            </div>
        </div>
    </Card>
);

const formatExpiration = (isoDate: string): string =>
    new Date(isoDate).toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: '2-digit',
    });
